/**
 * @fileoverview This file contains the definition of the 'LocaleService' service, which is responsible for managing the application's locale settings.
 * @module app.locale
 */

/**
 * @namespace app.locale
 */

/**
 * @typedef {Object} LocaleService
 * @property {function(): string} getLocaleDisplayName - Retrieves the display name of the current locale.
 * @property {function(localeDisplayName: string): Promise} setLocaleByDisplayName - Sets the locale based on its display name.
 * @property {function(): string[]} getLocalesDisplayNames - Retrieves an array of all available locale display names.
 */

/**
 * @function
 * @name LocaleService
 * @description AngularJS service that handles the application's locale settings.
 * @param {Object} $translate - AngularJS translation service.
 * @param {Object} LOCALES - Object containing locale information.
 * @param {Object} $rootScope - AngularJS root scope object.
 * @param {Object} tmhDynamicLocale - AngularJS dynamic locale service.
 * @param {Object} $http - AngularJS HTTP service.
 * @param {Object} $window - AngularJS window service.
 * @param {Object} $q - AngularJS promise service.
 * @returns {LocaleService} The LocaleService object.
 */
(function () {
    'use strict';
    angular.module('app.locale', [])
        .service('LocaleService', ['$translate', 'LOCALES', '$rootScope', 'tmhDynamicLocale', '$http', '$window', '$q', function ($translate, LOCALES, $rootScope, tmhDynamicLocale, $http, $window, $q) {
            // PREPARING LOCALES INFO
            var localesObj = LOCALES.locales;

            // locales and locales display names
            var _LOCALES = Object.keys(localesObj);
            if (!_LOCALES || _LOCALES.length === 0) {
                console.error('There are no _LOCALES provided');
            }
            var _LOCALES_DISPLAY_NAMES = [];
            _LOCALES.forEach(function (locale) {
                _LOCALES_DISPLAY_NAMES.push(localesObj[locale]);
            });


            // METHODS
            var checkLocaleIsValid = function (locale) {
                return _LOCALES.indexOf(locale) !== -1;
            };

            var setLocale = function (locale) {
                var deferred = $q.defer();
                if (!checkLocaleIsValid(locale)) {
                    console.error('Locale name "' + locale + '" is invalid');
                    deferred.reject();
                    return;
                }

                $rootScope.lang = locale;
                $window.lang = locale;
                $window.wootricSettings = {
                    account_token: "NPS-66c1ee71",
                    language: window.lang.split('-')[0].toUpperCase()
                };
                 $window.ybug_settings.language_override = locale.split('-')[0];
                 $window.ybug_settings.translations = {
                    "tr": {
                        "feedbackForm.Types.1": "Hata",
                        "feedbackForm.Types.2": "Geliştirme",
                        "feedbackForm.Types.3": "Soru",
                        "feedbackForm.Types.4": "Geri Bildirim",
                    } 
                 }
                document.tidioChatLang = locale === 'pt-PT' ? 'pt' : locale === 'es-ES' ? 'es' : locale;
                try {
                    $window.localStorage.setItem('NG_TRANSLATE_LANG_KEY', locale);
                    $window.localStorage.setItem('Language', locale);
                } catch (err) {
                    //ignored
                }
                $http.defaults.headers.common["Accept-Language"] = locale;
                document.cookie = 'langcode=' + locale;

                // asking angular-translate to load and apply proper translations

                $translate.use(locale).then(function () {
                    $translate.refresh();
                    deferred.resolve();
                });
                return deferred.promise;
            };

            // EVENTS
            // on successful applying translations by angular-translate
            $rootScope.$on('$translateChangeSuccess', function (event, data) {
                document.documentElement.setAttribute('lang', data.language.toLowerCase().replace(/_/g, '-')); // sets "lang" attribute to html
                moment.locale(data.language.toLowerCase().replace(/_/g, '-'));
                // asking angular-dynamic-locale to load and apply proper AngularJS $locale setting
                tmhDynamicLocale.set(data.language.toLowerCase().replace(/_/g, '-'));
            });

            return {
                getLocaleDisplayName: function () {
                    var currentLocale = "tr";
                    try {
                        currentLocale = $window.localStorage.getItem('NG_TRANSLATE_LANG_KEY');
                    } catch (err) {
                        //ignored
                    }
                    return localesObj[currentLocale];
                },
                setLocaleByDisplayName: function (localeDisplayName) {
                    return setLocale(
                        _LOCALES[
                        _LOCALES_DISPLAY_NAMES.indexOf(localeDisplayName) // get locale index
                        ]
                    );
                },
                getLocalesDisplayNames: function () {
                    return _LOCALES_DISPLAY_NAMES;
                }
            };
        }]);
})();